import { jsx as _jsx } from "react/jsx-runtime";
import { INVOICE_STATUSES, INVOICE_STATUS_LABELS } from "@/constants/invoices";
const STATUS_STYLES = {
    [INVOICE_STATUSES.PAID]: "bg-green-100 text-green-800",
    [INVOICE_STATUSES.PENDING]: "bg-yellow-100 text-yellow-800",
    [INVOICE_STATUSES.OVERDUE]: "bg-red-100 text-red-800",
    [INVOICE_STATUSES.CANCELLED]: "bg-gray-100 text-gray-800"
};
const isInvoiceStatus = (status)=>{
    return Object.values(INVOICE_STATUSES).includes(status);
};
export const InvoiceStatusBadge = ({ status })=>{
    if (!status) {
        return null;
    }
    const normalizedStatus = status.toUpperCase();
    if (!isInvoiceStatus(normalizedStatus)) {
        return null;
    }
    return /*#__PURE__*/ _jsx("span", {
        className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[normalizedStatus]}`,
        children: INVOICE_STATUS_LABELS[normalizedStatus]
    });
};
export default InvoiceStatusBadge;
